import {Route} from '@angular/router';

import {TournamentResolver} from 'shared/resolvers';
import {List} from './tournaments/list/list';
import {View} from './tournament/view/view';

export const routes: Route[] = [
  {
    path: '',
    component: List,
  },
  {
    path: ':tournamentId',
    component: View,
    resolve: {
      model: TournamentResolver,
    },
  },
];
